import React from 'react';
import LetterCard from '../Letters/LetterCard';
import {Letter, Hostage} from '../types';
import { useUser } from '../../context/UserContext';
import '../../style/LetterList.css';

type LetterListProps = {
  letters: Letter[]; 
  hostage: Hostage;
  onRefresh?: () => void; // Optional callback
  onDeleteLetter?: (id: string | undefined ) => void
};

const LetterList: React.FC<LetterListProps> = ({letters, hostage, onRefresh,onDeleteLetter}: LetterListProps) => {
  const { user } = useUser();

  // @ts-ignore
  return (
    <div className='letters-container'>
      {letters?.map((letter, index) => (
        <React.Fragment key={letter.id}>
          {!letter.replyToId && <hr className='letter-separator' />}
          <LetterCard 
            letter={letter} 
            hostage={hostage}
            onRefresh={onRefresh}
            onDeleteLetter={() => {
              if (onDeleteLetter) {
                onDeleteLetter(letter.id);
              }
            }}          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default LetterList;